import { render, staticRenderFns } from "./ModalAddNewShobe.vue?vue&type=template&id=235aa6f9&scoped=true&"
import script from "./ModalAddNewShobe.vue?vue&type=script&lang=js&"
export * from "./ModalAddNewShobe.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddNewShobe.vue?vue&type=style&index=0&id=235aa6f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235aa6f9",
  null
  
)

export default component.exports